import React from 'react';

// this file contains animations for confirm page needed for activating or creating apollo

interface IConfirmLogic {
  loading: boolean;
  success: boolean;
  t: any;
  heading: string;
  errorText: string;
  errorHeading: string;
  subheading?: string;
}

const ConfirmLogic: React.FC<IConfirmLogic> = ({
  loading,
  success,
  t,
  heading,
  errorHeading,
  errorText,
  subheading
}) => {
  if (loading) {
    return (
      <div className="p-16">
        <div role="status">
          <svg
            aria-hidden="true"
            className="inline w-[80px] h-[80px] fill-[#78BE20] animate-spin dark:text-transparent"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      </div>
    );
  } else {
    if (success) {
      return (
        <div className="w-full text-center pt-2">
          <svg
            className="checkmark"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              className="checkmark__circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="checkmark__check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
              strokeLinecap="round"
            />
          </svg>
          <h3 className="mt-12 mb-8">
            <b>{heading}</b>
            {subheading && (
              <>
                <br />
                <span>{subheading}</span>
              </>
            )}
          </h3>
        </div>
      );
    } else {
      return (
        <div className="w-full text-center">
          <div className="sweet-alert">
            <div className="icon error animateErrorIcon">
              <span className="x-mark animateXMark">
                <span className="line left"></span>
                <span className="line right"></span>
              </span>
            </div>
          </div>
          <div className="mb-6">
            <h3>
              <b>{errorHeading}</b>
            </h3>
            <p>{errorText}</p>
          </div>
        </div>
      );
    }
  }
};

export default ConfirmLogic;
